<template>
  <div class="withDraw">
    <el-steps :active="0" class="withDraw-stepBox">
      <el-step title="发起提现申请" icon="el-icon-admin-jinqian" :description="time.date1"></el-step>
      <el-step title="待审核" icon="el-icon-admin-daishenhe-copy" :description="time.date2"></el-step>
      <el-step title="商家携带发票对账" icon="el-icon-admin-fapiao" :description="time.date3"></el-step>
      <el-step title="待收款" icon="el-icon-admin-xianjinliuliangbiao" :description="time.date4"></el-step>
    </el-steps>
    <div class="container">
      <div class="left-right">
        <div class="left">总余额：</div>
        <div class="right">{{totel | fixed}}</div>
      </div>
      <div class="left-right">
        <div class="left">可提现总金额：</div>
        <div class="right">{{withdrawMoney | fixed}}</div>
      </div>
      <div class="tip-container">
        <div class="withdrawDes">注: 1.园区钱包 风险能预存期为{{rateDay}}天，({{date}}-23:59之后的收入为冻结金额，不可提现),平台服务费为{{rate*100}}%;</div>
        <div class="withdrawDes">2.第三方平台 风险能预存期为{{thirday}}天，({{thirdDate}}-23:59之后的收入为冻结金额，不可提现),平台服务费为{{thirdFeeRate*100}}%;</div>
        <div class="withdrawDes">3.润泽钱包支付的金额提现时需提供发票，微信/支付宝支付的金额提现时无需提供发票，优先提现无需提供发票的金额</div>
      </div>
      <div class="left-right">
      <div class="name">提现渠道</div>
      <div class="value">
        <div ><input v-model="type" type="radio" name="withdraw" value="1" @click="currentMayAccount = withdrawMoney;currentFeeRate = rate">园区钱包提现<span class="allWithdrawIntro"> (可提现金额：{{withdrawMoney}}元，未扣除{{rate*100}}%手续费)</span></div>
        <div ><input v-model="type" type="radio" name="withdraw" value="2" @click="currentMayAccount = thirdWithDrawMoney;currentFeeRate = thirdFeeRate">第三方平台提现<span class="allWithdrawIntro"> (可提现金额：{{thirdWithDrawMoney}}元，未扣除{{thirdFeeRate*100}}%手续费)</span></div>
      </div>
    </div>
    </div>
    

    <el-form ref="crashForm" :model="crashForm" label-width="80px" class="crashForm">
      
      <el-row type="flex" align="middle" class="withdraw-input">
        <el-col :span="10">
          <el-form-item label="提现金额">
            <el-input v-model="crashForm.money" placeholder="请输入提现金额" change="countRate()"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <el-form-item>
            <el-col :span="3">
              <span @click="allCrash" class="allWithdraw">全部提现</span>
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row
        class="realMoney"
      >*扣除平台服务费{{rateMoney | fixed}}元，实际到账金额为{{realMoney}}元，待交发票金额{{waitBillMoney}}元</el-row>

      <el-form-item label="提现描述">
        <el-col :span="18">
          <el-input
            type="textarea"
            :rows="4"
            :maxlength="150"
            resize="none"
            placeholder="请输入提现描述(150字以内)"
            v-model="crashForm.desc"
            class="crash-des"
            @input="remainLength()"
          ></el-input>
        </el-col>
      </el-form-item>
      <el-form-item>
        <el-button @click="submit" class="goToWithdraw">发起提现</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import logo from "../assets/images/step.png";
import suc from "../assets/images/arrowSuc.png";
import fail from "../assets/images/arrowFail.png";
import { mayWithdrawal, putWithdrawl } from "@/api/withdraw";

export default {
  data() {
    return {
      time: {
        date1: "",
        date2: "",
        date3: "",
        date4: ""
      },
      step: {
        date1: "发起提现申请",
        date2: "待审核",
        date3: "商家携带发票对账",
        date4: "待收款"
      },
      imgUrl: logo,
      arrowS: suc,
      arrowF: fail,
      crashForm: {
        money: "",
        desc: ""
      },
      withdrawMoney: 0,
      totel: 0,
      rate: 0.01,
      checked: false,
      result: 0,
      rateDay: 0,
      mchId: "",
      date: "",
      thirdWithDrawMoney:0,
      thirdAccount: "",
      thirdFeeRate: "",
      thirday: "",
      thirdDate:'',
      type:'1',
      currentMayAccount:0,//当前可提现的余额，这个值是根据提现渠道管变化的
      currentFeeRate:0,
    };
  },
  mounted() {
    this.mchId = this.$store.getters.mchId;
    mayWithdrawal(this.mchId)
      .then(res => {
        let {
          mayAccount,
          feeRate,
          account,
          day,
          date,
          mayThirdAccount,
          thirdAccount,
          thirdFeeRate,
          thirday,
          thirdDate
        } = res.data;
        this.totel = parseFloat(account).toFixed(2);
        this.withdrawMoney = parseFloat(mayAccount).toFixed(2) || 0;
        this.thirdWithDrawMoney = parseFloat(mayThirdAccount).toFixed(2) || 0;
        this.rate = feeRate;
        this.rateDay = day;
        this.date = date;
        this.thirdDate = thirdDate;
        this.thirdAccount = thirdAccount;
        this.thirdFeeRate = thirdFeeRate;
        this.thirday = thirday;
        /* 下面这两个赋值，是为了让刚进入页面默认选中园区提现时，让当前的可提现余额和费率是园区钱包提现的 */
        this.currentFeeRate = this.rate;
        this.currentMayAccount = this.withdrawMoney;
      })
      .catch(err => {});
  },
  methods: {
    remainLength: function() {
      let nowL = this.crashForm.desc.length;
      let remainL = 150 - nowL;
    },
    allCrash: function() {
      this.crashForm.money = this.currentMayAccount;
    },
    submit: function() {
      if (
        Number(this.crashForm.money) > 0 &&
        Number(this.crashForm.money) <= Number(this.currentMayAccount)
      ) {
        putWithdrawl(this.crashForm.money, this.crashForm.desc, this.mchId,this.type)
          .then(res => {
            this.$router.push({ path: "/main/indexshow" });
          })
          .catch(err => {});
      } else {
        this.$message.error("请填写正确提现金额");
      }
    }
  },
  computed: {
    rateMoney: function() {
      let rate = Math.ceil(this.crashForm.money * this.currentFeeRate * 100) / 100;
      return 0.0 || parseFloat(rate).toFixed(2);
    },
    realMoney: function() {
      let real =
        (this.crashForm.money * 100 -
          Math.ceil(this.crashForm.money * this.currentFeeRate * 100)) /
        100;
      return 0.0 || parseFloat(real).toFixed(2);
    },
    waitBillMoney: function() {
      let real = this.type == 2?0:this.realMoney
      return parseFloat(real).toFixed(2);
    }
  }
};
</script>
<style lang="scss" scoped>
%row{
  display: flex;
  flex-direction: row;
  align-items: center;
}
%col{
  display: flex;
  flex-direction: column;
  align-items: center;
}

@import "../style/_withdraw";

.withDraw {
  background-color: #fff;
  margin: 16px;
  width: 98%;
  .container{
    padding-left: 30px;
    .left-right{
      @extend %row;
      .left{
          height: 30px;
          line-height: 30px;
          font-size: 18px;
          color: #797979;
      }
      .right{
        color: #353535;
        margin-left: 4px;
      }
      .name{
        height: 60px;
        line-height: 20px;
        font-size: 14px;
        color: #353535;
      }
      .value{
        height: 60px;
        font-size: 14px;
        margin-left: 10px;
      }
    }
    .tip-container{
      margin: 20px 0 10px 0;
      >div{
        height: 25px;
        line-height: 25px;
        font-size: 12px;
        color: #ff5000;
      }
    }

  }
}
.el-question {
  color: #bfbfbf;
  margin-left: 12px;
  cursor: pointer;
}
.withdraw-input {
  height: 40px;
}
.allWithdraw {
  cursor: pointer;
  color: #3399ff;
  font-size: 14px;
}
.allWithdrawIntro {
  font-size: 12px;
  color: #949494;
}
.submit {
  width: 100%;
}
.goToWithdraw {
  width: 180px;
  height: 36px;
  border-radius: 4px;
  color: #fff;
  background-color: #30ce7f;
}
.withdrawDesTitle {
  height: 30px;
  line-height: 30px;
  font-size: 18px;
  color: #797979;
}
.withdrawDesMon {
  color: #353535;
  margin-left: 4px;
}
.withdrawDes {
  height: 25px;
  line-height: 25px;
}
.withdrawDesMargin {
  margin-bottom: 50px;
  margin-top: 15px;
  font-size: 12px;
  color: #ff5000;
}
.realMoney {
  font-size: 12px;
  color: #ff5000;
}
</style>




// WEBPACK FOOTER //
// src/components/Withdraw1.vue